// extracted by mini-css-extract-plugin
module.exports = {"container":"awardCard_container__11FG1","image":"awardCard_image__3MELw","middle":"awardCard_middle__3VphN","text":"awardCard_text__3TXi-","header":"awardCard_header__3ffkk"};